
import React from "react";
import USAMap from "react-usa-map";

// Map of state abbreviations to full names for service states
const statesFullName = {
  CA: "California", TX: "Texas", AZ: "Arizona", NM: "New Mexico", NV: "Nevada", CO: "Colorado", UT: "Utah",
  AL: "Alabama", AK: "Alaska", AR: "Arkansas", CT: "Connecticut", DE: "Delaware", FL: "Florida", GA: "Georgia",
  HI: "Hawaii", IA: "Iowa", ID: "Idaho", IL: "Illinois", IN: "Indiana", KS: "Kansas", KY: "Kentucky",
  LA: "Louisiana", MA: "Massachusetts", MD: "Maryland", ME: "Maine", MI: "Michigan", MN: "Minnesota",
  MO: "Missouri", MS: "Mississippi", MT: "Montana", NC: "North Carolina", ND: "North Dakota", NE: "Nebraska",
  NH: "New Hampshire", NJ: "New Jersey", NY: "New York", OH: "Ohio", OK: "Oklahoma", OR: "Oregon",
  PA: "Pennsylvania", RI: "Rhode Island", SC: "South Carolina", SD: "South Dakota", TN: "Tennessee",
  VA: "Virginia", VT: "Vermont", WA: "Washington", WI: "Wisconsin", WV: "West Virginia", WY: "Wyoming"
};

const serviceStates = ["CA", "TX", "AZ", "NM", "NV", "CO", "UT", "OR"];
const serviceColor = "#F97316"; // Darker orange
const defaultColor = "#fdba74"; // Lighter orange (Tailwind orange-300: #fdba74)
const textColor = "#fff";

// Get a map of state abbreviations to color (service states = darker, rest = lighter)
const customize = {};
Object.keys(statesFullName).forEach((abbr) => {
  customize[abbr] = { fill: serviceStates.includes(abbr) ? serviceColor : defaultColor };
});

function USColoredMap() {
  // Ref to SVG so we can overlay state abbreviations as white text
  const svgRef = React.useRef(null);

  React.useEffect(() => {
    // Overlay abbreviations as SVG text
    const svg = svgRef.current?.querySelector("svg");
    if (!svg) return;

    // Remove old labels (if any)
    Array.from(svg.querySelectorAll("text.us-map-abbr")).forEach(el => el.remove());

    // Attempt to center text in each state
    Object.entries(statesFullName).forEach(([abbr]) => {
      const path = svg.querySelector(`[data-name='${abbr}']`);
      if (!path) return;
      const bbox = path.getBBox();
      const cx = bbox.x + bbox.width / 2;
      const cy = bbox.y + bbox.height / 2;
      const text = document.createElementNS("http://www.w3.org/2000/svg", "text");
      text.setAttribute("x", cx);
      text.setAttribute("y", cy);
      text.setAttribute("text-anchor", "middle");
      text.setAttribute("dominant-baseline", "middle");
      text.setAttribute("font-size", "13");
      text.setAttribute("font-weight", "bold");
      text.setAttribute("fill", textColor);
      text.classList.add("us-map-abbr");
      text.style.pointerEvents = "none";
      text.textContent = abbr;
      svg.appendChild(text);
    });
  });

  return (
    <div className="w-full flex justify-center relative" ref={svgRef}>
      {/* USA Map - no onClick, onHover, tooltip, etc. */}
      <USAMap
        title="USA Map"
        customize={customize}
      />
    </div>
  );
}

export default USColoredMap;
